import { jsx as _jsx } from "react/jsx-runtime";
import cx from 'classnames';
import { Conditional, Map, MapMarker } from '../common';
import styles from './StoreLocationMap.module.scss';
import { CAT_POI_ICON } from './constants';
export const StoreLocationMap = ({ userCountryCode, dealerCode, latitude, longitude, className, onClick }) => {
    const coordinates = { lat: latitude, lng: longitude };
    const showStoreLocationMap = !!(longitude && latitude);
    const content = document.createElement('img');
    content.src = CAT_POI_ICON;
    return (_jsx(Conditional, { test: showStoreLocationMap, children: _jsx("div", { "data-testid": "location-map", className: cx(styles['store-location-map-container'], className), children: _jsx(Map, { userCountryCode: userCountryCode, dealerCode: dealerCode, center: coordinates, mapOptions: {
                    clickableIcons: false,
                    fullscreenControl: false,
                    zoomControl: false,
                    zoom: 10
                }, children: _jsx(MapMarker, { position: coordinates, content: content, onClick: onClick }) }) }) }));
};
